import React from "react"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import DynamicStripeWrapper from "components/stripe/DynamicStripeWrapper"

/**
 * Elements provider for the embedded experience booking page.
 *
 * The charge lands on the account of the guide who owns the experience, which is only known once
 * the experience has loaded — hence `isReady`.
 */
export default function StripeProviderWrapper({ children }) {
  const { experienceDetail } = useSelector((state) => state.experiences.experienceById)

  return (
    <DynamicStripeWrapper stripeAccountData={experienceDetail?.guide?.stripe_account_data} isReady={!!experienceDetail}>
      {children}
    </DynamicStripeWrapper>
  )
}

StripeProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired
}
